import gql from 'graphql-tag'
import {IDS} from "../../Constants/IDS";

export const SUBSCRIBE_ALL_TRIPS = gql`
    subscription($startDate:timestamptz,$endDate:timestamptz, $orgId:uuid!) {
        Trips: VehicleTrip(where: {created_at: {_gte: $startDate, _lte: $endDate},organizationId:{_eq: $orgId}}, order_by: {created_at: desc}){
            id
            tripId
            routeId
            statusId 
            TripStatus {id title}
            Route{
                id
                name
            }
            Vehicle{
                id
                name
                platNo
            }
            Driver{
                id
                name
            }
        }
    }`
export const SUBSCRIBE_NOT_UNLOADED_TRIPS = gql`
    subscription($startDate:timestamptz, $orgId:uuid!) {
        NotLoadedTrips: VehicleTrip(where: {created_at: {_lt: $startDate},organizationId:{_eq: $orgId}, statusId: {_neq:"${IDS.TripStatus.Unloaded}"}}, order_by: {created_at: desc}){
            id
            tripId
            routeId
            statusId 
            TripStatus {id title}
            created_at
            Route{
                id
                name
            }
            Vehicle{
                id
                name
                platNo
            }
            Driver{
                id
                name
            }
        }
    }`

export const SUBSCRIBE_TRIP_DETAILS_BY_ID = gql`
    subscription ($id: uuid){
        Trips: VehicleTrip(where: {id: {_eq: $id}}){
            id
            tripId
            statusId             
            TripStatus {id title}
            created_at            
            Route{id name}
            Vehicle{id name}
            Driver{id name}
            Order_aggregate {aggregate {count}}
            CreditDebit_aggregate {
                aggregate {sum {orderAmount amount}}
            }
            Expense {
                id
                amount
                note
                created_at
                Expenses{
                    id
                    title
                }
                ExpenseAttachments{
                    id
                    image
                }
            }
            GPSTracking(limit:1, order_by: {created_at: desc}){
                id
                lat
                long
            }
            VehicleTripStock(order_by: {Unit: {unit: asc}}){
                id
                initialQty
                currentQty
                unloadedQty
                productId
                unitId
                Product{
                    id
                    displayName
                    price
                    bunchPrice
                    retailer
                    weight
                    colorCode
                    packageType
                    image
                    bunchKg
                }
                Unit{
                    id
                    unit
                }
            }
            OrganizationStock{
                id
                quantity
                productId
                unitId
                organizationId
            }
            TripDestinations(order_by: {checkInTime: asc_nulls_last}){
                id
                shopId
                shopName
                checkInTime
                checkOutTime
                lastVisitedDate
                notes
                status
                timeSpent
                Order{
                    id
                    price
                    finalPrice
                    colloectedAmount
                }
            }
            CreatedBy{
              id
              name
            }
        }
    }`

export const SUBSCRIBE_TRIP_ORDER_DETAILS_BY_ID = gql`
    subscription ($tripId: uuid!, $tripDestinationId: uuid!){
        Trips: VehicleTrip(where: {id: {_eq: $tripId}}){
            id
            tripId
            Order(where: {to: {_eq: $tripDestinationId}}){
                id
                orderNum
                date
                orderItemCount
                gstPrice
                colloectedAmount
                price
                finalPrice
                orderNum
                previousDueAmount
                Organization{
                    id
                    name
                    totalDueAmount
                }
                OrderItems{
                    id
                    quantity
                    price
                    perUnitPrice
                    Product{
                        id
                        displayName
                        image
                        containerType
                    }
                    Unit{
                        id
                        unit
                    }
                }
            }
        }
    }`

export const SUBSCRIBE_LAST_CHECKIN_TRIP = gql`
    subscription ($id: uuid){
        Trips: VehicleTrip(where: {id: {_eq: $id}}){
            id
            TripDestinations(order_by: {checkInTime: desc_nulls_last}, limit: 1) {
                id
                shopName
                checkInTime
            }
        }}`
